/* import __COLOCATED_TEMPLATE__ from './phone-details-call-section.hbs'; */
/* RESPONSIBLE TEAM: team-phone */

type TranscriptMessage = {
  speaker?: string;
  speaker_label?: string;
  start_time: string;
  content: string;
};

type DropdownOption = {
  text: string;
  icon: string;
  onSelectItem: () => void;
  isDestructive: boolean;
  isDisabled: boolean;
};

interface Args {
  recordingUrl?: string;
  transcript?: TranscriptMessage[];
  transcriptStatusText: string;
  dropdownOptions: Array<{ items: DropdownOption[] }>;
  onPlay: () => void;
  isVideo?: boolean;
  hasRecordingError?: boolean;
  recordingDeleted: boolean;
  additionalCallDetailsLoaded: boolean;
  speakerLabel: (message: TranscriptMessage) => string;
  noRecordingText?: string;
  dropdownTestId?: string;
  optionsButtonTestId?: string;
}

import Component from '@glimmer/component';

export default class PhoneDetailsCallSection extends Component<Args> {
  // Provide computed property to satisfy ESLint rule
  get hasRecording(): boolean {
    return Boolean(this.args.recordingUrl);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::PhoneDetailsCallSection': typeof PhoneDetailsCallSection;
    'inbox2/phone-details-call-section': typeof PhoneDetailsCallSection;
  }
}
